<div *ngIf="socialUser">
  <span>{{ socialUser.name }} </span>
  <button (click)="signOut()" mat-raised-button>Sign Out</button>
</div>
